import { NUMBER_OF_COLUMNS_ON_MOBILE, NUMBER_OF_COLUMNS_ON_LARGE_DEVICES } from "./constants";
export var getGridColumns = function getGridColumns(isUserOnMobile) {
  return isUserOnMobile ? NUMBER_OF_COLUMNS_ON_MOBILE : NUMBER_OF_COLUMNS_ON_LARGE_DEVICES;
};